<template>
  <div class="container" v-if="loaded">
    <div class="row">
      <div class="col-xs-12 col-lg-5">
        <div
          class="btn-group mb-4 mt-4 w-100 lightShadow"
          role="group"
          aria-label="Button group with nested dropdown"
        >
          <button type="button" class="btn btn-light active font-weight-bold">
            IOR
          </button>
          <button type="button" class="btn btn-light font-weight-bold">
            Special
          </button>

          <div class="btn-group" role="group">
            <button
              id="dateRange"
              type="button"
              class="btn btn-light dropdown-toggle font-weight-bold"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Day
            </button>
            <div class="dropdown-menu lightShadow" aria-labelledby="dateRange">
              <button class="dropdown-item">Day</button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item">Week</button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item">Month</button>
            </div>
          </div>
          <div class="btn-group" role="group">
            <button
              id="sortBy"
              type="button"
              class="btn btn-light dropdown-toggle font-weight-bold"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Sort
            </button>
            <div
              class="dropdown-menu lightShadow"
              aria-labelledby="sortBy"
              id="sortByDropdown"
            >
              <button
                class="dropdown-item sortByDropdownItem"
                v-on:click="sortIRS($event, 'number')"
              >
                IR Number
              </button>
              <div class="dropdown-divider"></div>
              <button
                class="dropdown-item sortByDropdownItem sortByActive"
                v-on:click="sortIRS($event, 'startTime')"
              >
                Date
              </button>
              <div class="dropdown-divider"></div>
              <button
                class="dropdown-item sortByDropdownItem"
                v-on:click="sortIRS($event, 'level')"
              >
                Level
              </button>
              <div class="dropdown-divider"></div>
              <button
                class="dropdown-item sortByDropdownItem"
                v-on:click="sortIRS($event, 'company')"
              >
                Company
              </button>
              <div class="dropdown-divider"></div>
              <button
                class="dropdown-item sortByDropdownItem"
                v-on:click="sortIRS($event, 'status')"
              >
                Status
              </button>
            </div>
          </div>
        </div>
        <div class="list-group lightShadow listOverflow">
          <IRListItems />
        </div>
      </div>
      <div class="col mt-4">
        <div class="card w-100 m-0 lightShadow">
          <div class="card-header">
            <ul class="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link disabled"
                  href="#"
                  tabindex="-1"
                  aria-disabled="true"
                  >#{{ $store.getters.ir.ir_number }}</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="ir-tab"
                  data-toggle="tab"
                  href="#ir"
                  role="tab"
                  aria-controls="ir"
                  aria-selected="true"
                  >IR</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="files-tab"
                  data-toggle="tab"
                  href="#files"
                  role="tab"
                  aria-controls="files"
                  aria-selected="false"
                  >Files</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="history-tab"
                  data-toggle="tab"
                  href="#history"
                  role="tab"
                  aria-controls="history"
                  aria-selected="false"
                  >History</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="complete-tab"
                  data-toggle="tab"
                  href="#complete"
                  role="tab"
                  aria-controls="complete"
                  aria-selected="false"
                  >Complete IR</a
                >
              </li>
            </ul>
          </div>

          <IRDetails />

          <div
            class="card-footer text-muted d-flex justify-content-between align-items-center"
          >
            <small>IR Created At: 07/22/19 9:31 AM</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IRListItems from "../components/IRListItems";
import IRDetails from "../components/IRDetails";
const fb = require("../firebaseConfig");

export default {
  name: "Home",
  components: {
    IRListItems,
    IRDetails
  },
  data: function() {
    return {
      loaded: false
    };
  },
  methods: {
    sortIRS: function(e, property) {
      let sorted = this.$store.getters.irs;

      if (property === "status") {
        this.$store.commit(
          "sortIRS",
          sorted.sort(function(a, b) {
            if (a.status < b.status) {
              return -1;
            }
            if (a.status > b.status) {
              return 1;
            }
            return 0;
          })
        );
      } else if (property === "company") {
        this.$store.commit(
          "sortIRS",
          sorted.sort(function(a, b) {
            if (a.contact.company < b.contact.company) {
              return -1;
            }
            if (a.contact.company > b.contact.company) {
              return 1;
            }
            return 0;
          })
        );
      } else {
        this.$store.commit(
          "sortIRS",
          sorted.sort(function(a, b) {
            return a[property] - b[property];
          })
        );
      }

      let items = Array.from(
        document.getElementsByClassName("sortByDropdownItem")
      );
      items.map(item => item.classList.remove("sortByActive"));

      e.target.classList.add("sortByActive");
    }
  },
  mounted() {
    var useThis = this;
    this.$store
      .dispatch("loadIRS")
      .then(function() {
        const irID = useThis.$store.getters.irs[0].id;
        useThis.$store
          .dispatch("loadIR", irID)
          .then(() => (useThis.loaded = true))
          .catch(err => console.log(err));
      })
      .catch(err => console.log(err));
    // this.$store.dispatch("loadIRTypes");
  }
};
</script>

<style scoped>
.btn-group button {
  border-left: 1px solid #dfdfdf;
}

#irDisplay {
  background: #fff;
}

.listOverflow {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.form-control {
  color: #000;
}

.sortByActive {
  color: #6c757d;
}
</style>
